module.exports = __webpack_public_path__ + "static/media/OASIS-BNB-APE.944b0f77.png";